import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LoginRegister from '../../Login/login'; // Import the LoginRegister component

const PartnerRegistrationNavBar = () => {
  const [isModalVisible, setIsModalVisible] = useState(false); // State to manage modal visibility
  const [hidePersonalAccount, setHidePersonalAccount] = useState(false); // State to control hiding Personal Account tab
  const [activeTab, setActiveTab] = useState('business'); // State to manage the active tab

  // Function to open the Sign-In modal, hide the Personal Account tab, and set the active tab to "Business"
  const handleSignInClick = (e) => {
    e.preventDefault(); // Prevent default link action
    setHidePersonalAccount(true); // Set to hide the Personal Account tab
    setActiveTab('business'); // Set the active tab to "Business Account"
    setIsModalVisible(true); // Show the modal
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalVisible(false); // Hide the modal
    setHidePersonalAccount(false); // Reset to show both tabs when modal is reopened
  };

  return (
    <>
      <nav className="bg-white shadow-md py-4">
        <div className="container mx-auto flex justify-between items-center px-3">
          {/* Logo on the left */}
          <Link
            to="/"
            className="text-2xl font-bold hover:text-blue-950"
            style={{
              background: 'linear-gradient(to right, #6a11cb, #2575fc)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent',
            }}
          >
            Bookurspot
          </Link>

          {/* Sign in link on the right */}
          <div>
            <button
              className="text-blue-900 hover:text-blue-950"
              onClick={handleSignInClick} // Handle click to open the modal
            >
              Already a member? <span className="font-semibold underline">Sign in here</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Sign-In modal */}
      <LoginRegister
        isVisible={isModalVisible}
        onClose={handleCloseModal}
        hidePersonalAccount={hidePersonalAccount} // Pass the prop to hide Personal Account tab
        initialTab={activeTab} // Pass the active tab to the modal
      />
    </>
  );
};

export default PartnerRegistrationNavBar;
